// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__y+3i2","active":"style_active__SsMe4","paymentSucessInner":"style_paymentSucessInner__vtL79","SuccBtn":"style_SuccBtn__3pd81"};